export const FEATURE_FLAG = {
  ENABLE_CADC_SOLANA: 'ENABLE_CADC_SOLANA',
  ENABLE_BASE: 'ENABLE_BASE',
  ENABLE_OTC: 'ENABLE_OTC',
  ENABLE_25000_LIMIT_INCREASE: 'ENABLE_25000_LIMIT_INCREASE',
  ENABLE_SEND_NEW_CADC: 'ENABLE_SEND_NEW_CADC',
  ENABLE_RECEIVE_NEW_CADC: 'ENABLE_RECEIVE_NEW_CADC',
  ENABLE_REJECT_OLD_CADC: 'ENABLE_REJECT_OLD_CADC',
  ENABLE_CADC_MIGRATION: 'ENABLE_CADC_MIGRATION',
} as const

export type FeatureFlagKey = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG]
